<script setup lang="ts">
import type { Team } from '~/types'

interface Props {
  team?: Team.Model
}

const props = defineProps<Props>()
const index = useId()

const { id: adId, code: adCode } = useAdParams(props.team)
const { elementId, unit } = useGoogleAdParams({
  id: adId,
  code: adCode,
  baseUnit: '/$id/xfl/ufl-en/$code',
  index,
})

// Define responsive ad sizes
const sizeMapping: googletag.SizeMappingArray = [
  // Desktop: ≥1320px → 1280x100
  [[1320, 0], [[1280, 100]]],

  // Tablet: ≥768px → 728x90
  [[768, 0], [[728, 90]]],

  // Mobile: Default → 320x50
  [[0, 0], [[320, 50]]],
]
</script>

<template>
  <AdGoogle
    v-if="elementId && unit"
    :id="elementId"
    :unit
    :size-mapping
    class="ad-placement"
  />
</template>

<style lang="scss">
.ad-placement {
  @apply mx-auto my-[40px] flex justify-center text-center;
  @apply lg:my-[80px];
  @apply print:hidden;
}
</style>
